export default __webpack_public_path__ + "a627c7003f600025a835e6efe73a751b.svg";